module.exports = __webpack_public_path__ + "img/waste.da6fd2c6.gif";